export default function Logo({ className = '' }: { className?: string }) {
  return (
    <img
      src="/imagem/imagem_300px_sem_metadata.webp"
      alt="Eletrônica 2000"
      className={className}
      width={160}
      height={40}
      loading="eager"
    />
  );
}
